export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl () {
    switch (window.location.host) {
      case '4growth.wser.wur.nl':
        return 'https://4growth.wser.wur.nl/WebApi'
      case 'acc.4growth.wser.wur.nl':
        return 'https://acc.4growth.wser.wur.nl/WebApi'
      case 'tst.4growth.wser.wur.nl':
        return 'https://tst.4growth.wser.wur.nl/WebApi'
      default:
        return 'http://localhost:55910'
    }
  }

  public static getDataservicesUrl () {
    switch (window.location.host) {
      case '4growth.wser.wur.nl':
        return 'https://dataservices.wser.wur.nl/'
      case 'acc.4growth.wser.wur.nl':
        return 'https://acc.dataservices.wser.wur.nl/'
      case 'tst.4growth.wser.wur.nl':
        return 'https://tst.dataservices.wser.wur.nl/'
      default:
        return 'https://tst.dataservices.wser.wur.nl/'
    }
  }
}
